import { GoalSetterModalLauncher, SwingGuideLauncher } from '@blocks';

export const ModalLauncher = () => {
    return (
        <>
            <SwingGuideLauncher />
            <GoalSetterModalLauncher />
        </>
    );
};
